import Toast from '@/components/Toast/index';
// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from '@/componentsDS/Breadcrumbs/index';
import Breadcrumb from '@/dsComponents/Breadcrumb';
import Button from "@/componentsDS/Button/Button";
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import FilterMenu from '@/pages/onboarding/components/FilterMenu';
import Icon from '@/componentsDS/Icon/Icon';
import InputDropdown from '@/dsComponents/select/InputDropdownSelect/index';
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterLeft, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { DataElementOutlined } from "@dextech-ai/dex-design-system/icons";
import MultiLayerTable from "@/componentsDS/MultiLayerTable/index";
import Search from '@/componentsDS/Search/index';
import useModal from '@/hooks/use-modal';
import usePage from "@/hooks/use-page/index";
import useToast from '@/hooks/use-toast';
import { useQuery } from "@/lib/router-dom";
import api from '@/services/api/clientRelation';
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { categorizeFilters, extractUniqueValuesUsingMap, generateQueryString, searchRecords, updateFilterByParams } from '../../helpers/index';
import MultipleEmailAddressInput from '../MultipleEmailAddressInput/index';
import AddRelationBtn from '../AddRelationBtn/index';
import { Box, DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@dextech-ai/dex-design-system';

const RenderGroupByTrigger = ({ groupByDropdownOptions }) => {
	return (
		<span>
			<Icon name="list-view" style="solid" size="medium" /> <span>Group By: {groupByDropdownOptions[0]?.label}</span>
		</span>
	)
}

const RenderFilterTrigger = () => {
	return (
		<span>
			<Icon name="adjustments-horizontal" style="solid" size="medium" /> <span>Filter</span>
		</span>
	)
}

export const createBody = (orgId, serviceProviderOrgId, flow, dataElementId) => {
	return {
		"dataOwnerOrgId": serviceProviderOrgId,
		"serviceProviderOrgId": orgId,
		"dataElementId": dataElementId,
		"initiater": "SERVICE_PROVIDER",
		"flow": flow
	};
};

export const createEmailBody = (orgId, email, flow, dataElementId) => {
	return {
		"dataOwnerOrgId": null,
		"serviceProviderOrgId": orgId,
		"dataElementId": dataElementId,
		"invitedViaEmail": email,
		"flow": flow,
		"initiater": "SERVICE_PROVIDER",
	};
};

export const handleData = (dataElementArr, orgIdArr, flow, orgId, orgEmailList,orgEmail) => {
	const clientProvidersLists = [];
	if (dataElementArr.length && orgIdArr.length) {
		dataElementArr.forEach((dataElementId) => {
			orgIdArr.forEach(clientOrgId => {
				if (clientOrgId.id === 'inviteNewUser') {
					if(orgEmail){
						clientProvidersLists.push(createEmailBody(orgId, orgEmail, flow, dataElementId.id));
					}
					orgEmailList.forEach(email => {
						clientProvidersLists.push(createEmailBody(orgId, email, flow, dataElementId.id));
					});
				}
				else {
					clientProvidersLists.push(createBody(orgId, clientOrgId.id, flow, dataElementId.id));
				}
			});
		});
	}
	return clientProvidersLists;
};


const ClientTablePage = ({
	title,
	description,
	data,
	headers,
	emptyMessage,
	refreshData,
	setRefreshData,
	customGroupHeaderRender,
	organizationItems,
	pitstopItems,
	dataElementContributeItems,
	dataElementConsumeItems,
	clientLoading,
	orgDataLoading,
	pitstopsLoading,
	dataElementLoading,
}) => {

	// Get Profile
	const profile = useSelector(state => state.auth.profile);
	const orgId = profile?.organizationId;

	const { breadcrumbsItems } = usePage({
		title: title,
		breadcrumbs:[{
			label: '',
			link: `/`,
		},
		{
			label: title,
			link: ``
		}]
	});

	// Toast Message
	const toastType = {
		success: "success",
		error: "error"
	}
	const { toastList, addToastMessage } = useToast()
	const [loading, setLoading] = useState(false);

	const { visible: initiateAddClientRelationModal, show: showInitiateAddClientRelationModal, hide: hideInitiateAddClientRelationModal } = useModal()

	// Email List
	const [orgEmailList, setOrgEmailList] = useState([]);
	const [orgEmail,setOrgEmail]= useState("")
	const  [isOrgEmailValid, setIsOrgEmailValid] = useState(false)

	const  [organizationData, setOrganizationData] =useState([])
	useEffect(() => {
		if (organizationItems.length) {
			setOrganizationData([{ id: 'inviteNewUser', label: 'Invite New User', value: 'inviteNewUser' }, ...organizationItems])
		}
	}, [organizationItems])

	// Dropdown search
	const [dropdownSearch, setDropdownSearch] = useState({
		pitstop: '',
		organization: '',
		dataElementContribute: '',
		dataElementConsume: ''
	})

	const handleDropdownSearch = (e) => {
		if (e?.target) {
			const { name, value } = e.target;
			setDropdownSearch(prev => ({ ...prev, [name]: value }));
		}
	}

	// Multi Select Filter Dropdown Items
	const [selectOrgIds, setSelectOrgIds] = useState([]);
	const [selectPitstops, setSelectPitstops] = useState([]);
	const [sendDataElement, setSendDataElement] = useState([]);
	const [consumeDataElement, setConsumeDataElement] = useState([]);

	// Query Params
	const [, setSearchParam] = useSearchParams()

	const query = useQuery();
	const [dataOwnerOrgName, dataElementQueryParams, statusQueryParams] = ['from', 'dataElement', 'status'].map(item => query.get(item))

	const [filterDropdownOption, setFilterDropdownOption] = useState([]);

	// HANDLER FUNCTIONS
	const resetData = () => {
		setSelectOrgIds([])
		setSelectPitstops([])
		setSendDataElement([])
		setConsumeDataElement([])
		setOrgEmailList([])
	}

	const openModal = () => {
		resetData()
		showInitiateAddClientRelationModal()
	}

	const handleSubmit = async () => {
		setLoading(true);
		const serviceProvidersLists = [];

		if (sendDataElement.length) {
			handleData(sendDataElement, selectOrgIds, 'SEND', orgId, orgEmailList, orgEmail).forEach(item => serviceProvidersLists.push(item));
		}

		if (consumeDataElement.length) {
			handleData(consumeDataElement, selectOrgIds, 'RECEIVE', orgId, orgEmailList, orgEmail).forEach(item => serviceProvidersLists.push(item));
		}

		const payload = {
			'serviceProviders': serviceProvidersLists,
			pitstops: selectPitstops?.map((value) => value.id)
		}

		const [error] = await api.addClientRelationship(payload);
		setLoading(false)
		if (error) {
			return addToastMessage(error.message ?? "Failed to add Client Relationship.", toastType.error)
		}

		hideInitiateAddClientRelationModal();
		addToastMessage("Client relationship requests sent!", toastType.success)
		return setRefreshData(!refreshData);
	}

	/*=================================================
		Search
	/================================================*/
	const [searchValueForClient, setSearchValueForClient] = useState('');

	/*=================================================
		Filter
	/================================================*/
	const categoryLabelMap = {
		dataElementName: 'Data Element Name',
		dataOwnerOrgName: 'Client',
		status: 'Status'
	};

	const LABEL_ID_MAP = [
		{ labelKey: 'dataElementName', idKey: 'dataElementId' },
		{ labelKey: 'dataOwnerOrgName', idKey: 'dataOwnerOrgId' },
		{ labelKey: 'status', idKey: 'status' }
	]

	const statusIdMapper = {
		APPROVED: 2,
		ACTIVE: 2,
		INACTIVE: 3,
		REVOKED: 4,
		PENDING: 5,
		'PENDING_YOUR_APPROVAL': 6,
		"PENDING YOUR APPROVAL": 6,
		REJECTED: 7
	}

	const finalFilterOptions = LABEL_ID_MAP.flatMap(item => extractUniqueValuesUsingMap(data, item.labelKey, item.idKey, orgId, categoryLabelMap)).map(item => item.category === "Status" ? ({ ...item, id: statusIdMapper[item.id] }) : item)
	/*=================================================
		Search and Filter Logic
	/================================================*/

	//  Filter Dropdown Options handler function
	const updateFilterDropdownOptions = (elem) => {
		setFilterDropdownOption(() => [...elem])
		const filterArrSchema = {
			from: ["Client"],
			dataElement: ["Data Element Name"],
			status: ["Status"]
		}

		const filterArr = categorizeFilters(elem, filterArrSchema)
		const query = generateQueryString(filterArr)
		setSearchParam(query)
	}

	// set filters by params or when user refresh the page
	useEffect(() => {
		if (!data) return;
		let updatedFilters = [];
		if (dataOwnerOrgName) {
			const dataOwnerResult = updateFilterByParams(data, dataOwnerOrgName, 'dataOwnerOrgId', 'dataOwnerOrgName', 'Client')
			if (dataOwnerResult.length) {
				updatedFilters = [...updatedFilters, ...dataOwnerResult]
			}
		}
		if (dataElementQueryParams) {
			const dataElementResult = updateFilterByParams(data, dataElementQueryParams, 'dataElementId', 'dataElementName', 'Data Element Name')
			if (dataElementResult.length) {
				updatedFilters = [...updatedFilters, ...dataElementResult]
			}
		}
		if (statusQueryParams) {
			statusQueryParams.split(',').forEach(status => {
				updatedFilters.push({
					id: parseInt(statusIdMapper[status]),
					label: status.toUpperCase(),
					category: "Status"
				});
			})
		}
		if (updatedFilters.length) {
			setFilterDropdownOption(prevFilters => [...prevFilters, ...updatedFilters]);
		}
		return () => {
			setFilterDropdownOption([])
		}
	}, [dataOwnerOrgName, dataElementQueryParams, statusQueryParams, data]);

	// to update table record when user check/uncheck filter
	const filterData = useMemo(() => {
		let filtered = data;

		if (filterDropdownOption.length > 0) {
			filtered = data.filter((item) => {
				const categoryMatch = {};

				filterDropdownOption.forEach((filter) => {
					if (filter.category === 'Data Element Name') {
						categoryMatch['Data Element Name'] = categoryMatch['Data Element Name'] || filter.orgId === item.dataElementId;
					}
					if (filter.category === 'Client') {
						categoryMatch['Client'] = categoryMatch['Client'] || item.dataOwnerOrgName ? filter.orgId === item.dataOwnerOrgId : filter.label === item.dataOwnerEmail;
					}
					if (filter.category === 'Status') {
						categoryMatch['Status'] = categoryMatch['Status'] || filter.id === item.statusCode;
					}
				});

				const allCategoriesMatch = Object.values(categoryMatch).every(Boolean);
				return allCategoriesMatch;
			});
		}

		if (searchValueForClient) {
			const fieldsToSearch = ['dataElementName', 'dataOwnerOrgName'];
			filtered = filtered.filter(item => searchRecords(item, fieldsToSearch, searchValueForClient));
		}

		return filtered;
	}, [data, filterDropdownOption, searchValueForClient]);

	/*=================================================
		Group By
	/================================================*/
	const groupByOption = [
		{ id: 'dataElementName', label: 'Data Element' },
		{ id: 'dataOwnerOrgName', label: 'Client' },
		{ id: 'serviceProviderRelationshipStatus', label: 'Status' }
	];

	const [groupByDropdownOptions, setGroupByDropdownOptions] = useState([{ id: 'dataOwnerOrgName', label: 'Client' }]);

	return (
		<>
			{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
			{/* <Breadcrumbs breadcrumbItems={breadcrumbsItems} /> */}
			<Breadcrumb items={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{title}</div>
				</div>
			</div>

			<div className="title-header--sub-header">{description}</div>

			<Box display="flex" align="center">
				<div className="title-header__actionable__left">
					<Search value={searchValueForClient || ''} onChange={(e) => setSearchValueForClient(e?.target?.value ?? e)} onCancel={() => setSearchValueForClient('')} id="my-client-search" />

					<FilterMenu
						options={finalFilterOptions}
						value={filterDropdownOption}
						onChange={updateFilterDropdownOptions}
						trigger={<RenderFilterTrigger />}
						isLoading={clientLoading}
						noResults={data.length === 0}
						id="my-client-filter-dropdown"
					/>

					<DropdownMenu placement="bottomLeft">
						<DropdownMenuTrigger asChild>
							<div className="DS__dropdown-wrapper">
								<Button
									type={ButtonType.UTILITY}
									variant={ButtonVariant.UTILITY}
									dataTestId="my-client-group-by-dropdown"
									text={<RenderGroupByTrigger groupByDropdownOptions={groupByDropdownOptions} />}
								/>
							</div>
						</DropdownMenuTrigger>
						<DropdownMenuContent>
							<DropdownMenuRadioGroup
								value={groupByDropdownOptions[0]?.id}
								onValueChange={(value) => setGroupByDropdownOptions(groupByOption.filter((option) => option.id === value))}
							>
								{groupByOption.map((option) => (
									<DropdownMenuRadioItem key={option.id} itemKey={option.id} value={option.id}>
										<span id="my-client-group-by-dropdown">{option.label}</span>
									</DropdownMenuRadioItem>
								))}
							</DropdownMenuRadioGroup>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>

				<div className="title-header__actionable__right">
					<div className="data-exchange-actions-header">
						<div className="data-exchange-actions-header__left">
						</div>
						<div className="data-exchange-actions-header__right">
							<Button
								variant={ButtonVariant.STANDARD}
								type={ButtonType.SOLID}
								data-testid="add-button"
								text={"+ Add Client"}
								onClick={() => {
									openModal()
								}}
								id="my-client-add-client-button"
							/>
						</div>
					</div>
				</div>
			</Box>

			<MultiLayerTable
				data={filterData}
				headers={headers}
				groupBy={groupByDropdownOptions[0]?.id}
				rowSize="large"
				emptyMessage={emptyMessage}
				customGroupHeaderRender={customGroupHeaderRender}
				loading={clientLoading}
				sortBy="modified"
				id="my-client-column-sort-"
			/>

			<Modal visible={initiateAddClientRelationModal} close={hideInitiateAddClientRelationModal} dismissClickOutsideModal={false}>
				<ModalHeader icon={<DataElementOutlined data-ds-color="primary-dark" />}>
					<ModalTitle>Add Client</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<div>
						<div className="card-configure__body__dropdown">
							<span className="card-configure__body__dropdown__title">
								Client
							</span>
							<InputDropdown
								placeholder={"Select Organization(s)"}
								name={"organization"}
								dropdownOption={organizationData}
								dropdownSelectedOption={selectOrgIds}
								onSelectDropdownItem={setSelectOrgIds}
								multipleSelection
								value={dropdownSearch.organization}
								onChange={handleDropdownSearch}
								fullWidth
								isLoading={orgDataLoading}
							/>
						</div>
						{/* If user has selected 'To invite new user' in To dropdown */}
						{selectOrgIds?.find(item => item.value === 'inviteNewUser') &&
							<MultipleEmailAddressInput
								emailList={orgEmailList}
								setEmailList={setOrgEmailList}
								emailText={"Can't find the Organization you are looking for?"}
								validateExistingEmail={true}
								email={orgEmail}
								setEmail={setOrgEmail}
								isTypedEmailValid={isOrgEmailValid}
								setIsTypedEmailValid={setIsOrgEmailValid}
							/>
						}

						{/* If User has selected 'I will provide/consume the data in Via dropdown and If there are more than 1 Pitstops */}
						{pitstopItems?.length > 1 && <div className="card-configure__body__dropdown">
							<span className="card-configure__body__dropdown__title">
								Pitstop
							</span>
							<div className="card-configure__body__dropdown__option">
							<InputDropdown
								placeholder={"Select Pitstop(s) to host"}
								name={"pitstop"}
								dropdownOption={pitstopItems.filter((pitstop) => pitstop.label.toLowerCase().includes(dropdownSearch.pitstop.toLowerCase()))}
								onSelectDropdownItem={setSelectPitstops}
								multipleSelection
								dropdownSelectedOption={selectPitstops}
								value={dropdownSearch.pitstop}
								onChange={handleDropdownSearch}
								fullWidth
								isLoading={pitstopsLoading}
							/>
							</div>
						</div>}

						<hr className='card-configure__separation-line' />
						<div className='card-configure__body__text'>
							<div>Select the data elements that you would like to contribute </div>
							<div>and/or consume:</div>
						</div>

						{/* Dropdown - For sending and receiving the Data Elements */}
						<div className="card-configure__body__dropdown">
							<span className="card-configure__body__dropdown__title">
								Data Element(s) to contribute
							</span>
							<div className="card-configure__body__dropdown__option">
							<InputDropdown
								placeholder={"Select Data Element(s)"}
								name={"dataElementContribute"}
								dropdownOption={dataElementContributeItems.filter((dataElement) => dataElement.label.toLowerCase().includes(dropdownSearch.dataElementContribute.toLowerCase()))}
								dropdownSelectedOption={sendDataElement}
								onSelectDropdownItem={setSendDataElement}
								multipleSelection
								value={dropdownSearch.dataElementContribute}
								onChange={handleDropdownSearch}
								fullWidth
								isLoading={dataElementLoading}
							/>
							</div>
						</div>
						<div className="card-configure__body__dropdown">
							<span className="card-configure__body__dropdown__title">
								Data Element(s) to consume
							</span>
							<div className="card-configure__body__dropdown__option">
							<InputDropdown
								placeholder={"Select Data Element(s)"}
								name={"dataElementConsume"}
								dropdownOption={dataElementConsumeItems.filter((dataElement) => dataElement.label.toLowerCase().includes(dropdownSearch.dataElementConsume.toLowerCase()))}
								dropdownSelectedOption={consumeDataElement}
								onSelectDropdownItem={setConsumeDataElement}
								multipleSelection
								value={dropdownSearch.dataElementConsume}
								onChange={handleDropdownSearch}
								fullWidth
								isLoading={dataElementLoading}
							/>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<ModalFooterLeft>
						<Button
							text="Cancel"
							type={ButtonType.GHOST}
							variant={ButtonVariant.STANDARD}
							data-testid="cancel-client-button"
							onClick={() => {
								hideInitiateAddClientRelationModal();
							}}
							id="my-client-modal-cancel-button"
						/>
					</ModalFooterLeft>
					<ModalFooterRight>
						<AddRelationBtn
							onClick={handleSubmit}
							text={"Add"}
							{...{
								selectOrgIds,
								consumeDataElement,
								sendDataElement,
								orgEmailList,
								orgEmail,
								isOrgEmailValid
							}}
							id="my-client-modal-add-button"
						/>
					</ModalFooterRight>
				</ModalFooter>
			</Modal>

			<Toast toastList={toastList} />
		</>
	)
}

export default ClientTablePage

ClientTablePage.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			render: PropTypes.func,
			sortable: PropTypes.bool
		})
	).isRequired,
	emptyMessage: PropTypes.string.isRequired,
	refreshData: PropTypes.bool.isRequired,
	setRefreshData: PropTypes.func.isRequired,
	customGroupHeaderRender: PropTypes.func,
	loading: PropTypes.bool,
	organizationItems: PropTypes.array,
	pitstopItems: PropTypes.array,
	dataElementContributeItems: PropTypes.array,
	dataElementConsumeItems: PropTypes.array,
	clientLoading: PropTypes.bool,
	orgDataLoading: PropTypes.bool,
	pitstopsLoading: PropTypes.bool,
	dataElementLoading: PropTypes.bool,
};

RenderGroupByTrigger.propTypes = {
	groupByDropdownOptions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired
		})
	).isRequired
};
